import * as ko from 'knockout';
import { trialTraitDetail, TrialTraitDetailData, TrialTraitDetailMDM } from '../../api/measurement_metas';
import { app } from '../../app';
import i18n from '../../i18n';
import { ATTRIBUTE_TYPES_WITH_DDM } from '../../models/measurement_meta';
import { TrialWizard } from '../../models/trial';
import { measurementMetaLibraryEdit } from '../../screens/measurement_meta_library_edit';
import { Deferred } from '../../utils/deferred';
import * as datasetsApi from '../../api/datasets';

const template =
  require('raw-loader!../../../templates/components/trial_wizard/trial_trait_details.html').default;

class TrialTraitDetailsScreen {
  loading = ko.observable(true);
  result: Deferred<{}>;
  entity = ko.observable<TrialTraitDetailData>();

  constructor(params: { id: string; result: Deferred<{}> }) {
    this.result = params.result;
    this.load(params.id);
  }

  private async load(id: string) {
    this.entity(await trialTraitDetail(id));
    this.loading(false);
  }

  formattedType(): string {
    for (let attr of ATTRIBUTE_TYPES_WITH_DDM) {
      if (attr.value === this.entity().type) {
        return attr.name();
      }
    }
  }

  formatDimNames(data: TrialTraitDetailMDM): string {
    return data.dim_names.join(', ');
  }

  onClose = () => {
    this.result.resolve(null);
  };
}

const trialTraitDetailsScreen = {
  name: 'trial-trait-details',
  viewModel: TrialTraitDetailsScreen,
  template,
};

ko.components.register(trialTraitDetailsScreen.name, trialTraitDetailsScreen);

export function openTrialTraitDetails(id: string) {
  app.formsStackController.push({
    title: i18n.t('Trait details')(),
    name: trialTraitDetailsScreen.name,
    isBig: true,
    showNav: true,
    params: { id, result: new Deferred() },
  });
}

export function openTrialTraitEdit(
  id: string,
  wizard?: TrialWizard,
  onSaved?: (data: datasetsApi.MeasurementMetaData) => void
) {
  app.formsStackController.push({
    title: i18n.t('Trait edit')(),
    name: measurementMetaLibraryEdit.name,
    isBig: false,
    showNav: true,
    params: {
      management: false,
      forEdit: true,
      id,
      result: new Deferred(),
      wizard: wizard,
      onSaved: onSaved,
    },
  });
}

/**
 * Open the trait edit form pre-filled from a library trait, saving it as a per-trial copy.
 *
 * Resolves with the created copy, or rejects with no value if the user cancels.
 */
export function openTrialTraitEditForCreate(
  libraryMmId: string,
  wizard: TrialWizard
): Promise<datasetsApi.MeasurementMetaData> {
  return app.formsStackController.push({
    title: i18n.t('Add trait')(),
    name: measurementMetaLibraryEdit.name,
    isBig: false,
    showNav: true,
    params: {
      management: false,
      forEdit: false,
      id: libraryMmId,
      result: new Deferred<datasetsApi.MeasurementMetaData>(),
      wizard,
    },
  });
}
